import useSWR from 'swr';
import { PropelUserModel, UserService } from '../../api';

const usersFetcher = async (): Promise<PropelUserModel[]> => UserService.getUsers();

export const useUsers = () => {
  const { data, error, isLoading } = useSWR({ opId: 'getUsers' }, usersFetcher, { revalidateOnFocus: false });
  return { users: data ?? [], isLoading, isError: error };
};
